/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1TutoraiUsageQueryResponse,
  GetApiV1TutoraiUsageQueryParams,
  GetApiV1TutoraiUsage401,
  GetApiV1TutoraiUsage500,
} from "../../types/tutorAIUsageController/GetApiV1TutoraiUsage.ts";

function getGetApiV1TutoraiUsageUrl() {
  const res = { method: "GET", url: `/api/v1/tutorai/usage` as const };
  return res;
}

/**
 * @description Retorna métricas detalhadas de consumo de tokens para o aluno. Período padrão: últimos 30 dias. Os limites (`dailyLimit`, `monthlyLimit`, `weeklyLimit`) sempre refletem o dia/semana/mês correntes, independente do filtro de período. **(Requer Authorization para autenticação)**
 * @summary Relatório de uso de tokens por aluno (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/usage}
 */
export async function getApiV1TutoraiUsage(
  params?: GetApiV1TutoraiUsageQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1TutoraiUsageQueryResponse,
    ResponseErrorConfig<GetApiV1TutoraiUsage401 | GetApiV1TutoraiUsage500>,
    unknown
  >({
    method: "GET",
    url: getGetApiV1TutoraiUsageUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
